module.exports = __webpack_public_path__ + "static/media/vegitables_42.9f6e5737.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_42.csv
// module id = 627
// module chunks = 0